import React, { useState, useEffect } from 'react';
import { Device, DeviceListItem } from '../types';
import {
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  IconButton
} from '@mui/material';

import { UAParser } from 'ua-parser-js';
import { useTranslation } from 'react-i18next';

import CloseIcon from '@mui/icons-material/Close';
import { format } from 'date-fns';

const parser = new UAParser();

/**
 * List of devices. Device could be removed.
 * @param props
 */
export default function(props: {
  devices: Device[];
  update: () => Promise<void>;
  remove: (deviceId: string) => Promise<boolean>;
}) {
  const { t } = useTranslation();

  const [list, setList] = useState<DeviceListItem[]>([]);

  useEffect(() => {
    setList(
      props.devices.map(device => ({
        device,
        disabled: false
      }))
    );
  }, [props.devices]);

  /**
   * Replace one element in state to another, with disabled status. After call service.
   * @param item
   */
  async function handleRemove(item: DeviceListItem) {
    setList(list => {
      const newList = [...list];
      const index = newList.findIndex(
        current => current.device.deviceId === item.device.deviceId
      );
      if (index !== -1) {
        const item = newList[index];
        item.disabled = true;
        newList.splice(index, 1, item);
      }
      return newList;
    });
    const success = await props.remove(item.device.deviceId);
    if (success) {
      await props.update();
    }
  }

  return (
    <List>
      {list.map(item => {
        parser.setUA(item.device.userAgent);
        return (
          <ListItem key={item.device.deviceId}>
            <ListItemText
              primary={parser.getOS().name}
              secondary={
                <>
                  {format(
                    new Date(item.device.lastActiveAt),
                    'dd.MM.yyyy HH:mm'
                  )}{' '}
                  - {t('browser')} {parser.getBrowser().name} - {item.device.ip}
                </>
              }
            />
            <ListItemSecondaryAction>
              <IconButton
                edge="end"
                aria-label="Remove"
                onClick={e => handleRemove(item)}
                disabled={item.disabled}
              >
                <CloseIcon />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
        );
      })}
    </List>
  );
}
